import React, { useEffect } from 'react';
import { Route, Switch, useRoute, useLocation } from 'wouter';
import useCurrentUser from '../hooks/useCurrentUser';
import { useDispatch } from '../config/store';

import Layout from '../components/layout/Layout';
import Welcome from '../pages/welcome';
import Interviews from '../pages/interviews';
import Interview from '../pages/interview';

function NavRoutes() {
  const { isAuthenticated, loading, loaded, jwtToken } = useCurrentUser();
  const dispatch = useDispatch();

  // Always redirect the root to /interviews, for now
  const [_location, setLocation] = useLocation();
  const [match, _params] = useRoute('/');
  useEffect(() => {
    if (match) setLocation('/interviews');
  }, [match]);

  // After authentication, get and store user info
  useEffect(() => {
    if (isAuthenticated) dispatch({ type: 'GET_CURRENT_USER', jwtToken });
  }, [isAuthenticated]);

  const userStatus = !isAuthenticated && !loading ? 'signedOut' : 'signedIn';

  return (
    <Layout userStatus={userStatus}>
      <Switch>
        <Route path='/'>
          <Welcome status={userStatus} />
        </Route>

        {isAuthenticated && loaded && (
          <>
            <Route path='/interviews' component={Interviews} />
            <Route path='/interviews/404'>{params => <Welcome status={params.rest} />}</Route>
            <Route path='/interviews/:id' component={Interview} />
          </>
        )}

        <Route path='/:rest*'>{params => <Welcome status={params.rest} />}</Route>
      </Switch>

      {/* Loading states for testing purposes: */}
      {/* {loading && <div>Loading...</div>} */}
      {/* {loaded && <div>Loaded</div>} */}
      {/* {isAuthenticated && loaded && <div>Authenticated and loaded</div>} */}
    </Layout>
  );
}

export default NavRoutes;
